import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const putAdditionalDepartments = (body) =>
  requestsTemplates.put(mainPath, `/employee/department/`,body);
